module.exports = __webpack_public_path__ + "img/icon (6).8f31da44.png";